import { VARIANT } from '@/constants';
import { type AccordionProps, Accordion as CommonAccordion } from '@monorepo/common';

function Accordion({ children, isOpened, startHeight }: AccordionProps) {
  return (
    <CommonAccordion isOpened={isOpened} startHeight={startHeight}>
      {children}
    </CommonAccordion>
  );
}

export default Accordion;
